export default {
	'select-account': 'Lütfen hesap seçin',

	'the-account': 'hesap?',

	'main-info': 'Ana Bilgi',
	'account-name': 'Hesap Adı',
	'main-account': 'Ana Hesap',
	'account-no-automatic-or-manual': 'Hesap Numarası (otomatik ya da manuel)',

	'account-type': 'Hesap Türü',

	'final-account': 'Kesin Hesap',
	'is-hidden': 'Hesabı gizle',
	notes: 'Notlar',

	'info-account': {
		'phone-number': 'Telefon Numarası',
		'tax-number': 'Vergi Numarası',
		address: 'Adres',
		email: 'E-posta',
		'mobile-number': 'Cep Telefonu Numarası'
	},

	tabs: {
		info: 'Bilgiler',
		'custom-prices': 'Özel Fiyatlar'
	}
}